(function ($) {
    $(function () {
        // ==============================================================================
        // LAZYLOAD
        // ==============================================================================
        $(".lazy").Lazy({
            effect: "fadeIn",
            effectTime: 300,
            onError: function (element) {
                console.log("error loading " + element.data("src"));
            },
        });

        // ==============================================================================
        // VIDEO POSITIE IN HERO
        // ==============================================================================

        var waitForFinalEvent = (function () {
            var timers = {};
            return function (callback, ms, uniqueId) {
                if (!uniqueId) {
                    uniqueId = "Don't call this twice without a uniqueId";
                }
                if (timers[uniqueId]) {
                    clearTimeout(timers[uniqueId]);
                }
                timers[uniqueId] = setTimeout(callback, ms);
            };
        })();

        if ($(".bgvideo").length) {
            // Vuur een aantal keer achter elkaar:
            var aantalkeer = 0;
            var intervalID = setInterval(function () {
                videoposition("bgvideo");

                if (++aantalkeer === 5) {
                    window.clearInterval(intervalID);
                }
            }, 100);

            // Vuur na window resize:
            $(window).resize(function () {
                waitForFinalEvent(
                    function () {
                        videoposition("bgvideo");
                    },
                    500,
                    "some unique string"
                );
            });
        }

        function videoposition(videoelement) {
            if ($("." + videoelement).length) {
                var heroheight = $("." + videoelement)
                    .parent()
                    .outerHeight();
                var herowidth = $("." + videoelement)
                    .parent()
                    .width();

                $(".abouthero .videocontainer").height(heroheight);

                if (heroheight / 9 < herowidth / 16) {
                    $("." + videoelement).width(herowidth);
                    $("." + videoelement).height((herowidth / 16) * 9);
                } else {
                    $("." + videoelement).height(heroheight);
                    $("." + videoelement).width((heroheight / 9) * 16);
                }

                // Centreer video ongeacht verhouding of grootte van div
                $("." + videoelement).css("left", "50%");
                $("." + videoelement).css(
                    "margin-left",
                    "-" + $("." + videoelement).width() / 2 + "px"
                );

                $("." + videoelement).css("top", "50%");
                $("." + videoelement).css(
                    "margin-top",
                    "-" + $("." + videoelement).height() / 2 + "px"
                );
            }
        }

        // ==============================================================================
        // TOEPASSINGSLIDER
        // ==============================================================================
        if ($(".toepassingslider").length) {
            $(".slider-big").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                lazyLoad: "ondemand",
                arrows: false,
                dots: true,
                asNavFor: ".slider-small",
            });
            $(".slider-small").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                lazyLoad: "ondemand",
                asNavFor: ".slider-big",
                dots: false,
                slidesToShow: 1,
                centerMode: false,
                variableWidth: true,
                arrows: true,
                focusOnSelect: true,
            });
        }

        // ==============================================================================
        // CTA SLIDER
        // ==============================================================================
        if ($(".cta-slider").length) {
            $(".cta-slider ").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                lazyLoad: "ondemand",
                arrows: true,
                dots: true,
            });
        }

        // ==============================================================================
        // HERO IMAGE SLIDER
        // ==============================================================================
        if ($(".bgimages-slider").length) {
            $(".bgimages-slider").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                lazyLoad: "ondemand",
                arrows: false,
                dots: false,
                infinite: true,
                asNavFor: ".bgimages-thumb-slider",
            });
            $(".bgimages-thumb-slider").slick({
                lazyLoad: "ondemand",
                asNavFor: ".bgimages-slider",
                dots: false,
                variableWidth: false,
                arrows: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                variableWidth: true,
                centerMode: false,
                focusOnSelect: true,
            });
        }

        // ==============================================================================
        // HERO IMAGE SLIDER
        // ==============================================================================
        if ($(".tobeslider").length) {
            if ($(window).width() <= 480) {
                $(".tobeslider").slick({
                    dots: true,
                    lazyLoad: "ondemand",
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    variableWidth: true,
                    infinite: true,
                    centerMode: true,
                });
            }
        }

        // ==============================================================================
        // Collectie slider
        // ==============================================================================
        if ($(".collection-slider").length) {
            $(".collection-slider").slick({
                dots: true,
                arrows: true,
                lazyLoad: "ondemand",
                slidesToShow: 4,
                slidesToScroll: 4,
                autoplay: false,
                variableWidth: false,
                infinite: true,
                centerMode: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            infinite: true,
                            dots: true,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });
        }

        // ==============================================================================
        // MONSTER FORM
        // ==============================================================================

        if ($("#Form_MonsterForm").length) {
            const monsterboxFields = $(".change_monsterbox");
            const monsterColorFields = $("input.change_monster");

            // On load check if hidden is filled, then check corresponding checkboxes
            $("#Form_MonsterForm .hidden").each(function () {
                if ($(this).val() == "1") {
                    var itemid1 = $(this).attr("id").substring(17);
                    $("#Form_MonsterSelectForm_" + itemid1).prop(
                        "checked",
                        true
                    );
                }
            });

            // Initially disable all color fields
            monsterColorFields.prop("disabled", true);

            monsterboxFields.change(function () {
                if (this.value == "MonsterboxLarge") {
                    // Set monster colors to all 6 and disable editing of them
                    monsterColorFields.each(function () {
                        $(this).prop("checked", true);
                        $(this).prop("disabled", true);
                        var itemid2 = $(this).attr("id").substring(23);
                        $("#Form_MonsterForm_" + itemid2).val("1");
                    });
                } else if (this.value == "MonsterboxSmall") {
                    // Small selected, enable color fields and reset all color selections
                    monsterColorFields.prop("checked", false);
                    monsterColorFields.prop("disabled", false);

                    //Reset all inputs
                    $("#Form_MonsterForm .hidden.js_color_input").each(
                        function () {
                            $(this).val("0");
                        }
                    );
                }
            });

            // On monstercolor select:
            monsterColorFields.change(function () {
                var itemid2 = $(this).attr("id").substring(23);

                if ($(this).is(":checked")) {
                    $("#Form_MonsterForm_" + itemid2).val("1");
                    $(".form-monsterselect").removeClass("error");
                } else {
                    $("#Form_MonsterForm_" + itemid2).val("0");
                }

                if (
                    $(".change_monsterbox:checked").val() === "MonsterboxSmall"
                ) {
                    let checkedCount = $(".change_monster:checked").length;
                    $(".change_monster").each(function () {
                        if (checkedCount >= 2 && !$(this).is(":checked")) {
                            $(this).prop("disabled", true);
                        } else {
                            $(this).prop("disabled", false);
                        }
                    });
                }
            });

            $("#fake-submit").click(function (e) {
                var anyBoxesChecked = false;

                $(".change_monster").each(function () {
                    if ($(this).is(":checked")) {
                        anyBoxesChecked = true;
                    }
                });

                if (!anyBoxesChecked) {
                    console.log("error_path");
                    $(".form-monsterselect").addClass("error");
                    document
                        .getElementById("error-scrolltarget")
                        .scrollIntoView();
                } else {
                    $("#Form_MonsterForm").submit();
                }
            });
        }

        // Custom error placement
        if ($(".message.required").length) {
            $(".message.required").each(function () {
                var message = $(this)
                    .html()
                    .replace("*", "")
                    .replace('"', "")
                    .replace('"', "");
                $(this)
                    .parent()
                    .find("input")
                    .attr("placeholder", message)
                    .addClass("error");
                $(this).remove();
            });
        }

        // ==============================================================================
        // FIXED MENU BAR
        // ==============================================================================
        if ($("#header-tobefixed").length) {
            // When the user scrolls the page
            window.onscroll = function () {
                checkifsticky();
            };

            // Get the header
            var header = document.getElementById("header-tobefixed");

            // Get the offset position of the navbar
            var sticky = header.offsetTop;

            // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
            function checkifsticky() {
                if (window.pageYOffset > sticky) {
                    header.classList.add("sticky");
                    $("body").addClass("header-sticky");
                } else {
                    header.classList.remove("sticky");
                    $("body").addClass("header-sticky");
                }
            }
        }

        // ==============================================================================
        // MOBIEL MENU
        // ==============================================================================
        if ($(".mobmenu-trigger").length) {
            $(".mobmenu-trigger").click(function () {
                if ($("body").hasClass("mobmenu-open")) {
                    $(".mobmenu-container").removeClass("active");
                    $("body").removeClass("mobmenu-open");
                } else {
                    $(".mobmenu-container").addClass("active");
                    $("body").addClass("mobmenu-open");
                }
            });

            $(".has-sub .submenu-trigger").click(function () {
                if ($(this).parent().hasClass("current")) {
                    $(".has-sub").removeClass("current");
                } else {
                    $(this).parent().addClass("current");
                }
            });
        }

        // ==============================================================================
        // FAQ
        // ==============================================================================
        if ($(".faqitem").length) {
            $(".faqitem > h2").click(function () {
                if (!$(this).parent().hasClass("active")) {
                    $(this).parent().addClass("active");
                } else {
                    $(this).parent().removeClass("active");
                }
            });
        }

        // ==============================================================================
        // Haal kruisje weg bij eerste popup
        // ==============================================================================
        if ($(".popup--particulier-proffesioneel.featherlight-inner").length) {
            $(".featherlight-close").remove();
            $("body").addClass("disable--exit");
        }
    });
})(jQuery);
